import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { BANNER_LIST_TEXTS } from "../shared/constants";

interface Props {
  open: boolean;
  bannerTitle: string;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteBannerDialog: React.FC<Props> = ({
  open,
  bannerTitle,
  isDeleting,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog open={open} onClose={onCancel} data-testid="delete-banner-dialog">
      <DialogTitle>{BANNER_LIST_TEXTS.deleteConfirmTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText>{BANNER_LIST_TEXTS.deleteConfirmMessage(bannerTitle)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isDeleting}>
          {BANNER_LIST_TEXTS.cancelButton}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" disabled={isDeleting}>
          {BANNER_LIST_TEXTS.deleteButton}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteBannerDialog;
